import { invalidateLogbookSurfaces, queryKeys } from "@healthos/client-data";
import type { QueryClient } from "@tanstack/react-query";

/**
 * Invalidate every read surface a manual-signal write can change: the Today
 * ambient screen, the whole signal timeline (all windows, via the prefix),
 * GLP-1 dose tracking (a dose touch re-syncs reminders server-side), and
 * every Logbook tab's chart + history list (Task 12b, via
 * `invalidateLogbookSurfaces`) - a manual write is exactly the kind of
 * change Logbook's own edit/delete actions make. Shared by the log, edit,
 * and delete flows so they can never drift on which caches to refresh.
 */
export function invalidateManualSignalReads(queryClient: QueryClient): void {
  for (const queryKey of [
    queryKeys.ambient,
    queryKeys.signalTimelinePrefix,
    queryKeys.glp1Tracking,
  ]) {
    void queryClient.invalidateQueries({ queryKey });
  }
  invalidateLogbookSurfaces(queryClient);
}
